import type { LucideIcon } from "lucide-react";
import { forwardRef } from "react";
import { Button, type ButtonProps } from "./button";

export interface IconButtonProps extends Omit<ButtonProps, "size" | "children" | "asChild"> {
  /** Obligatorio: el tipo no compila sin etiqueta accesible. */
  "aria-label": string;
  icono: LucideIcon;
  /** `md` 44/40 · `sm` 36/32 (filas de tabla compacta, cabeceras de bloque). */
  tamano?: "md" | "sm";
}

/**
 * Boton que es solo un icono. Existe como wrapper y no como `size="icon"`
 * suelto porque el tipo obliga al `aria-label`: es el guardrail mas barato
 * contra los botones de icono mudos. El icono es decorativo (`aria-hidden`); el
 * nombre lo da la etiqueta.
 */
export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ icono: Icono, tamano = "md", variant = "ghost", cargando = false, ...props }, ref) => (
    <Button
      ref={ref}
      variant={variant}
      size={tamano === "sm" ? "icon-sm" : "icon"}
      cargando={cargando}
      {...props}
    >
      {/* Cargando, el Button ya pone su spinner: un segundo icono no entra en 40px. */}
      {cargando ? null : <Icono aria-hidden="true" />}
    </Button>
  ),
);
IconButton.displayName = "IconButton";
